import { ArrowUpDown, ChevronUp, ChevronDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";

export const SortHeader = ({ label, k, sortKey, sortDir, onToggle, align = "left" }) => {
    const active = sortKey === k;
    const Icon = !active ? ArrowUpDown : sortDir === "asc" ? ChevronUp : ChevronDown;
    return (
        <TableHead className={cn(align === "right" && "text-right", "whitespace-nowrap")}>
            <button
                onClick={() => onToggle(k)}
                className={cn(
                    "inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wide transition-colors hover:text-foreground",
                    active ? "text-foreground" : "text-muted-foreground",
                    align === "right" && "flex-row-reverse",
                )}
            >
                {label}
                <Icon className={cn("h-3.5 w-3.5", active ? "text-primary" : "text-muted-foreground/60")} />
            </button>
        </TableHead>
    );
};
